import React from "react";
import "./Team.css";
import headerLineImg from "../assets/images/degrad-inf-dcha.png";


const Team = () => {
  return (
    <>
      {/* HEADER */}
   <section className="team-header-section">
  <div className="team-header-row">
    <h1 className="team-title">Team</h1>
    <p className="team-subtitle">Meet our management team</p>
  </div>

  <div className="team-header-line"
  style={{ backgroundImage: `url(${headerLineImg})` }}></div>
</section>

      {/* TEAM GRID */}
      <section className="team-section">
        <div className="team-grid">

          {/* INTRO – COLUMN 1 */}
          <div className="team-intro">
            <p>
              Discover the passionate team behind Cinfa International, a diverse
              team of professionals who are fully committed to quality and
              service.
            </p>
          </div>

          {/* MEMBER 1 */}
       <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-1.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>


          {/* MEMBER 2 */}
          <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-2.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>

          {/* MEMBER 3 */}
          <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-3.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>
          {/* MEMBER 4 */}
         <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-4.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>
            <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-5.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>
               <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-6.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>
           <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-7.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>

           <div className="team-card">
  <div className="team-photo">
    <img src={require("../assets/images/team-8.jpg")} alt="Daniel Torrens" />

    {/* NAME ON CUT */}
    <h4 className="team-name-on-cut">
      Daniel<br />Torrens
    </h4>
  </div>

  <div className="team-info">
    <p className="team-role">
      <em>International Sales Manager</em><br />
      International Business Unit
    </p>
  </div>
</div>

        </div>
      </section>
    </>
  );
};

export default Team;
